import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EMendate from './E_Mandate';
import InterestCertificate from './Interest_Certificate';
import { raiseCommonServiceRequest, getdata, fetchServiceRequestStatusApiCallFun, useCheckRepaymentScheduleStatus, setActivity, useLoanByOpportunityId, loanapplicationdocumentApi, handleDownloadDocument } from '../../Global/Index';
import BeatLoader from "react-spinners/BeatLoader";
import ClipLoader from 'react-spinners/ClipLoader';
import './All Services.css'
import { useNavigate } from 'react-router-dom';
import DownloadWelcomeKit from './Download_Welcome_Kit';
import kyc from '../../Images/KYC.png'
import RepaymentSchedule from './Repayment_Schedule';
import DisbursalRequest from './DisbursalRequest';
import Dropdown from './Dropdown';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { TbSend } from 'react-icons/tb';
import ServiceStatus from './ServiceRequestStatus';

import { FaFileSignature, FaCalendarAlt, FaGift, FaHeartbeat, FaHome, FaUserMd, FaMoneyCheckAlt, FaFileInvoiceDollar, FaIdCard, FaBriefcaseMedical, FaCertificate } from 'react-icons/fa';

const override = {
    borderColor: "red",
    marginLeft: '1vw'

};

const overridee = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};




const Raiserequestmap = {
    'Request for Disbursal': 9,
    'Insurance Certificate Copy': 12,
    'Critical Illness Insurance': 14,
    'Life Insurance': 15,
    'Property Insurance': 16,
    'Health Insurance': 17,
};


const mapservicename = {
    'Generate Welcome Kit': 'Welcome Letter',
    'Request for Disbursal': 'Request for Disbursal',
    'Insurance Certificate Copy': 'Insurance Certificate Copy',

    'Critical Illness Insurance': 'Critical illness Insurance',
    'Life Insurance': 'Life Insurance',
    'Property Insurance': 'Property Insurance',
    'Health Insurance': 'Health Insurance',


    'Repayment Schedule': 'Repayment Schedule',
    'Interest Certificate': 'Interest Certificate'
}

const dmsAndServiceRequestMap = {
    'Health Insurance': 'Health Insurance Form',
    'Critical Illness Insurance': 'Critical Illness Premium',
    'Property Insurance': 'Property Insurance',
    'Life Insurance': 'Life Insurance',
}

const menuItems = {
    'E-Mandate': <FaFileSignature />,
    'Repayment Schedule': <FaCalendarAlt />,
    'Generate Welcome Kit': <FaGift />,
    'Life Insurance': <FaHeartbeat />,
    'Property Insurance': <FaHome />,
    'Health Insurance': <FaUserMd />,
    'Request for Disbursal': <FaMoneyCheckAlt />,
    'Generate Statement of Accounts': <FaFileInvoiceDollar />,
    'Re-KYC': <FaIdCard />,
    'Critical Illness Insurance': <FaBriefcaseMedical />,
    'Interest Certificate': <FaCertificate />
}






const Rekyc = () => {
    const theme = useTheme();
    return (
        <div className="kycmaincontainer">
            <div >
                <p className="rekycinstruction">Maximize Accuracy with <br /> <span className="rekycword">Re KYC </span>Solution <br />
                </p>
                <p style={{ margin: '2vh 0vw' }}>Go paperless Re-Know Your Customer process & stay up-to-date with your customer's information.</p>

                <button
                    style={{
                        margin: '1vw 0vw',
                        background: theme.palette.maincolor.buttoncolor,
                        color: theme.palette.maincolor.light,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem'
                    }}
                >
                    <TbSend size={20} />
                    <a href="https://isfc.my.salesforce-sites.com/logInReKYC" target="_blank" rel="noopener noreferrer" className="kychref" style={{ color: theme.palette.maincolor.light }} >

                        <span>Re-KYC </span>
                    </a>
                </button>

            </div>
            <img src={kyc} style={{ height: '19vw', windth: 'auto', marginTop: '2vw' }} alt='kyc' />
        </div>

    );
}


const Common = ({ activeservicename }) => {

    const inputRef = useRef(null);
    const [submitloader, setSubmitloader] = useState(false);
    const theme = useTheme();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const currentValue = inputRef.current.value;
        const descriptionRegex = /^[^<>{}&]*$/;
        const trimmedDescription = currentValue.trim();

        if (trimmedDescription === "") {
            toast.error("Description can't be blank");
            return;
        }

        if (currentValue.startsWith(' ')) {
            toast.error("Error: The Description must not begin with a space.");
            return;
        }

        if (!descriptionRegex.test(trimmedDescription)) {
            toast.error("Error: The Description contains invalid characters.");
            return;
        }
        try {
            setSubmitloader(true);
            let requestStatus = 'Pending';


            if (dmsAndServiceRequestMap[activeservicename]) {
                const dmsApiResponse = await loanapplicationdocumentApi();

                if (dmsApiResponse?.response?.data) {
                    const dmsResponseCategory = dmsApiResponse.response.data;

                    if (dmsResponseCategory && dmsResponseCategory.subCategories) {
                        dmsResponseCategory.subCategories.forEach(subCategory => {
                            if (subCategory.name === dmsAndServiceRequestMap[activeservicename] &&
                                subCategory.status === 'Uploaded' &&
                                subCategory.documents &&
                                subCategory.documents.length > 0
                            ) {
                                requestStatus = 'Closed'
                            }
                        });
                    }
                }
            }


            const customer_detail = {
                "RecordType": Raiserequestmap[activeservicename],
                "serviceName": mapservicename[activeservicename],
                "Description": currentValue,
                "Status": requestStatus
            }


            const resp = await raiseCommonServiceRequest(customer_detail);
            if (resp.response.status == "200" && resp.response.message == 'Success') {
                setSubmitloader(false);
                toast.success('Request has been successfully submitted');
                if (inputRef.current) {
                    inputRef.current.value = '';
                }
            } else if (resp.response.status === "419") {
                window.location.href = '/Session-Expired'
            } else if (resp.response.status === "500") {
                toast.error('Something went wrong. Please try again later!')
            } else if (resp.response.status === "401") {
                window.location.href = '/'
            } else if (resp.response.status === "503") {
                toast.warn(resp.response.message);
            }
            setSubmitloader(false);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Something went wrong. Please try again later!');
            return;
        }
    };

    return (
        <div id='container1' className='certificatecontainer' >
            <div className='activeservicenamemaincontainer'>
                Create New Service Request for <span className='activeservicenamesubcontainer' style={{ color: theme.palette.maincolor.light, marginRight: '8px' }}>
                    {activeservicename}
                </span>
            </div>
            <div style={{ paddingBottom: '2vh' }}>
                <textarea type="text" ref={inputRef} placeholder='Enter Request Details' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                        type="submit"
                        onClick={handleSubmit}
                        disabled={submitloader}
                        style={{
                            background: theme.palette.maincolor.buttoncolor,
                            color: theme.palette.maincolor.light,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem'
                        }}
                    >
                        {submitloader ? (
                            <>
                                <span>Processing</span>
                                <BeatLoader
                                    color="rgb(155,57,19)"
                                    loading={submitloader}
                                    cssOverride={override}
                                    size={6}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </>
                        ) : (
                            <>
                                <TbSend size={20} />
                                <span>Submit</span>
                            </>
                        )}
                    </button>
                </div>

            </div>
        </div>
    )
}


const fetchStatusOfDisbursalRequestFromRequestStatusApi = async () => {

    const resp = await fetchServiceRequestStatusApiCallFun();
    if (resp.response.status == "200" && resp.response.message == 'Success') {
        const activeloanstatus = resp.response.data;
        const filteredRequest = activeloanstatus.filter(item => (item.requestName == "Subsequent Disbursement" || item.requestName == 'Disbursal Request' || item.requestName == 'Request for Disbursal'));
        const sortedRequests = filteredRequest.sort(
            (a, b) => new Date(b.createDate) - new Date(a.createDate),
        );

        return sortedRequests;
    } else {
        return [];
    }
};




const Subsequent_Disbursement = () => {
    const [index, setIndex] = useState(1);
    const theme = useTheme();
    // ...................................................................................
    const [activeservicename, setActiveservicename] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 720);
    const [oppertunityId, setOppertunityId] = useState(null);
    const [sortedRequestsForDisbursal, setSortedRequestsForDisbursal] = useState([]);
    const [pendingDisbursementAmount, setPendingDisbursementAmount] = useState(null);

    // Memoize processed service names to avoid recalculation
    const [servicerequestnames, setServicerequestnames] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 720);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Helper function to handle API response status
    const handleApiResponse = useCallback((data) => {
        if (data.response.status == '200') {
            setOppertunityId(data.response.data.OpportunityId);
        } else if (data.response.status === "500") {
            toast.error('Something went wrong. Please try again later!');
        } else if (data.response.status === "503") {
            toast.warn(data.response.message);
        } else if (data.response.status === "419") {
            window.location.href = '/Session-Expired';
        }
    }, []);

    useEffect(() => {
        const getdatafunction = async () => {
            const data = await getdata();
            const serviceRequestStatusData = await fetchStatusOfDisbursalRequestFromRequestStatusApi();
            setSortedRequestsForDisbursal(serviceRequestStatusData);
            handleApiResponse(data);
        }
        getdatafunction()
    }, [handleApiResponse])


    useEffect(() => {
        if (activeservicename) {
            setIndex(1);
        }
    }, [activeservicename])

    useEffect(() => {
        if (localStorage.getItem('ActiveService') === "1") {
            setActiveservicename('E-Mandate');
            localStorage.removeItem('ActiveService');
        } else {
            setActiveservicename(null);
        }
    }, []);

    const { data: rePaymentStatus, isLoading: isLoadingRepayment, error: repaymentError, } = useCheckRepaymentScheduleStatus();
    const { data: dashboardData, loan, isLoading: isLoadingLoan, error: loanError } = useLoanByOpportunityId(oppertunityId);

    const isLoading = isLoadingRepayment || repaymentError || isLoadingLoan || loanError;

    // helper functions to prevent unnecessary recalculations
    const shouldShowRepaymentSchedule = useCallback((repaymentdata) => {
        if (repaymentdata?.response?.data === undefined) {
            return false;
        }
        const individualdata = repaymentdata?.response?.data[0];
        return individualdata?.allowreplayment;
    }, []);

    const shouldShowStatementOfAccounts = useCallback((item, loan) => {
        return ((loan.LoanStatus == 'Partially Disbursed' || loan.LoanStatus == 'Fully Disbursed (Active)') && item.Is_Active__c);
    }, []);

    const shouldShowRequestForDisbursal = useCallback((_, loan) => {
     
        setPendingDisbursementAmount(loan.PendingDisbursement);

        const loanConditions = (
            loan.PendingDisbursement != 0 &&
            loan.LoanStatus == 'Partially Disbursed' &&
            loan.LastDisbursementDate == true &&
            loan.BalanceCollectable == 0.0
        );


        const requestConditions = (
            sortedRequestsForDisbursal.length == 0 ||
            sortedRequestsForDisbursal[0]?.requestStatus === 'Closed' ||
            sortedRequestsForDisbursal[0]?.requestStatus === 'Rejected'
        );

        return loanConditions && requestConditions;

    }, [sortedRequestsForDisbursal]);

    const filterService = useCallback((item, repaymentdata, loan) => {
        if (item.Name === "E-Mandate") {
            return false;
        }

        if (item.Name === "Update Personal Info" || item.Name === "Request ACH Update") {
            return false;
        }

        if (item.Name === "Repayment Schedule") {
            return shouldShowRepaymentSchedule(repaymentdata);
        }

        if (item.Name === "Generate Statement of Accounts") {
            return shouldShowStatementOfAccounts(item, loan);
        }

        if (item.Name === "Subsequent Disbursement Request"
            || item.Name === 'Disbursal Request'
            || item.Name === 'Request for Disbursal') {
            const decisionValue = shouldShowRequestForDisbursal(item, loan);
            return decisionValue;
        }

        return item.Is_Active__c;
    }, [shouldShowRepaymentSchedule, shouldShowStatementOfAccounts, shouldShowRequestForDisbursal]);


    const handleDashboardDataStatus = useCallback((dashboardData) => {
        if (!dashboardData) return;

        const status = dashboardData?.response?.status;
        if (status == '503') {
            toast.warn(dashboardData?.response?.message);
        } else if (status == '419') {
            window.location.href = "/Session-Expired"
        } else if (status == '500') {
            toast.error('Something went wrong. Please try again later!');
        } else if (status == '401') {
            window.location.href = '/'
        }
    }, []);


    const processServiceNames = useCallback((dashboardData, rePaymentStatus, loan) => {
        let isEmandate = 0;
        let dashboardDataVal = dashboardData?.response?.data;

        const allServiceName = dashboardDataVal?.allowedServicesList?.filter(item => {
            if (item.Name === "E-Mandate") {
                isEmandate = 1;
                return false;
            }
            return filterService(item, rePaymentStatus, loan);
        }).map(item => item.Name);


        if (isEmandate) {
            allServiceName.unshift('E-Mandate');
        }

        allServiceName.forEach((serviceName, index) => {
            allServiceName[index] = serviceName.replace('Subsequent Disbursement Request', 'Request for Disbursal');
        });


        return allServiceName;
    }, [filterService]);


    useEffect(() => {
        if (!isLoading && loan && dashboardData && rePaymentStatus) {
            const processedServiceNames = processServiceNames(dashboardData, rePaymentStatus, loan);
            setServicerequestnames(processedServiceNames);
        }
    }, [isLoading, loan, dashboardData, rePaymentStatus, processServiceNames]);


    const renderActiveServiceContent = useCallback((activeservicename) => {
        switch (activeservicename) {
            case 'E-Mandate':
                return <EMendate />;
            case 'Interest Certificate':
                return <InterestCertificate />;
            case 'Generate Welcome Kit':
                return <DownloadWelcomeKit />;
            case 'Re-KYC':
                return <Rekyc />;
            case 'Repayment Schedule':
                return <RepaymentSchedule />;
            case 'Generate Statement of Accounts':
                return navigate('/success/Account-Statement');
            case 'Request for Disbursal':
                return <DisbursalRequest amount={pendingDisbursementAmount} />
            default:
                return <Common activeservicename={activeservicename} />;
        }
    }, [navigate, pendingDisbursementAmount]);


    useEffect(() => {
        handleDashboardDataStatus(dashboardData);
    }, [dashboardData, handleDashboardDataStatus]);


    const handleClickfun = useCallback((servicerequestname) => {
        if (servicerequestname == '') {
            return;
        }

        setActiveservicename(servicerequestname);
        setIndex(1);
        setActivity(`${servicerequestname} Page`);
    }, []);

    return (
        <>
            <ToastContainer />
            <div className="maincontainer">
                <h2>All Service Request</h2>
                <div className="mainsubcontainer allservicesmaincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                    {isLoading ? (
                        <ClipLoader
                            color={theme.palette.maincolor.light}
                            loading={true}
                            cssOverride={overridee}
                            size={30}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    ) : (
                        <>
                            {isMobileView && (
                                <div>
                                    <div className='allservicesDropdown'>
                                        {servicerequestnames && <Dropdown servicerequestnames={servicerequestnames} handleClickfun={handleClickfun} />}
                                    </div>
                                </div>
                            )}

                            <div className='allservices'>
                                {servicerequestnames?.map((item, index) => (
                                    <button
                                        key={index + 1}
                                        className='servicebutton'
                                        id={activeservicename === item ? 'active' : ''}
                                        onClick={() => handleClickfun(item)}
                                        style={{
                                            color: activeservicename === item ? 'white' : theme.palette.primary.main,
                                            border: '1px solid lightgray',
                                            backgroundColor: activeservicename === item ? 'rgb(155, 19, 74)' : theme.palette.background.alt,
                                            fontSize: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            padding: '8px 12px',
                                            margin: '2vh auto'
                                        }}
                                    >
                                        <span>{menuItems[item]}</span>
                                        <span>{item}</span>
                                    </button>
                                ))}
                            </div>

                            {activeservicename && (
                                <div className='allservicesmainsubcontainer'>
                                    {activeservicename !== 'Re-KYC' && (
                                        <div className="selectservicerequesttype" style={{ color: theme.palette.maincolor.light }}>
                                            <button onClick={() => setIndex(1)} className={`subsebutt ${index === 1 ? 'active' : ''}`} style={{ color: theme.palette.maincolor.light }}>Raise Request</button>
                                            <button onClick={() => setIndex(0)} className={`subsebutt ${index === 0 ? 'active' : ''}`} style={{ color: theme.palette.maincolor.light }}>View History</button>
                                        </div>
                                    )}
                                    {index === 1 ? (
                                        renderActiveServiceContent(activeservicename)
                                    ) : (
                                        <ServiceStatus activeservicename={activeservicename} />
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
}



// PropTypes validation
Common.propTypes = {
    activeservicename: PropTypes.string.isRequired,
};

ServiceStatus.propTypes = {
    activeservicename: PropTypes.string.isRequired,
};
export default Subsequent_Disbursement;

